import * as Sentry from '@sentry/browser';
import { sanitize } from 'services/GlitchTipService';

// GlitchTip is Sentry-compatible. It is imported first in index.js so errors
// thrown while the rest of the app loads are reported too.
// Without REACT_APP_GLITCHTIP_DSN (e.g. local dev) the SDK stays disabled.
Sentry.init({
    dsn: process.env.REACT_APP_GLITCHTIP_DSN,
    environment: process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV,
    // console.log output is kept as breadcrumbs: mask form values / tokens in it
    beforeBreadcrumb: (breadcrumb) =>
        breadcrumb.data ? { ...breadcrumb, data: sanitize(breadcrumb.data) } : breadcrumb
});
